if(!customElements.get('product-info-drawer')) {
    customElements.define(
        'product-info-drawer',
        class ProductInfoDrawer extends HTMLElement {
            constructor() {
                super();
                this.drawer = null;
                this.overlay = null;
                this.drawerTitle = null;
                this.cartDrawerObserver = null;
            }
        
            connectedCallback() {
                this.init();
                this.bindEvents();
            }
        
            disconnectedCallback() {
                // Clean up observers and event listeners
                if (this.cartDrawerObserver) {
                    this.cartDrawerObserver.disconnect();
                }
                this.removeEventListeners();
            }
        
            init() {
                // Find drawer elements
                this.drawer = this.querySelector('.product-info-drawer_container');
                this.overlay = this.querySelector('.product-info-drawer__overlay');
                this.drawerTitle = this.querySelector('.product_info-drawer__title');
            }
        
            bindEvents() {
                // Look for buttons in document if none found in component
                const drawerButtons = document.querySelectorAll('.drawer-button');
                if (drawerButtons.length === 0) {
                    console.log('No cart drawer buttons found!');
                    return;
                } 
                else {
                    drawerButtons.forEach(btn => {
                        this.setupDrawerButton(btn);
                    })
        
                }
        
                // Bind close buttons
                const closeButton = this.querySelector('.product-info-drawer__header .close-drawer') ||
                                   document.querySelector('.product-info-drawer__header .close-drawer');
                closeButton?.addEventListener('click', () => this.closeDrawer());
        
                this.overlay?.addEventListener('click', () => this.closeDrawer());
        
                // Bind escape key
                this.escapeHandler = (e) => {
                    if (e.key === 'Escape' && this.drawer?.classList.contains('drawer-open')) {
                        this.closeDrawer();
                    }
                };
                document.addEventListener('keydown', this.escapeHandler);
        
                // Setup cart drawer observer
                this.setupCartDrawerObserver();
            }
        
            setupDrawerButton(btn) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.openDrawer(btn);
                });
        
                // Change cursor when section doesn't exist
                const sectionId = btn.dataset.sectionId;
                const targetSection = document.getElementById(sectionId);
                if (!targetSection) {
                    btn.style.cursor = '';
                }
            }
        
            openDrawer(btn) {
                if (!this.drawer) return;
        
                // Get data attributes from the clicked button
                const title = btn.dataset.title;
                const sectionId = btn.dataset.sectionId;

                if (this.drawerTitle && title) {
                    this.drawerTitle.innerHTML = title.charAt(0).toUpperCase() + title.slice(1);
                }
                
                // Hide all drawer content sections
                document.querySelectorAll('[data-drawer-content]').forEach(section => {
                    section.style.display = 'none';
                });
                
                const targetSection = document.getElementById(sectionId);
                if (!targetSection) return;
        
                // Show target section
                targetSection.style.display = '';
                targetSection.style.visibility = 'visible';
                targetSection.style.opacity = '1';
                
                // Open drawer
                this.drawer.classList.add('drawer-open');
                document.body.classList.add('drawer-open');
                if (this.overlay) {
                    this.overlay.style.display = 'block';
                }
        
                // Dispatch custom event
                this.dispatchEvent(new CustomEvent('drawer-opened', {
                    detail: { title, sectionId },
                    bubbles: true
                }));
            }
        
            closeDrawer() {
                if (!this.drawer) return;
        
                // Hide all drawer content sections
                document.querySelectorAll('[data-drawer-content]').forEach(section => {
                    section.style.display = 'none';
                });
                
                // Close drawer
                this.drawer.classList.remove('drawer-open');
                document.body.classList.remove('drawer-open');
                if (this.overlay) {
                    this.overlay.style.display = 'none';
                }
                
                this.dispatchEvent(new CustomEvent('drawer-closed', {
                    bubbles: true
                }));
            }
        
            setupCartDrawerObserver() {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && this.drawer) {
                    this.cartDrawerObserver = new MutationObserver(() => {
                        if (cartDrawer.classList.contains('active') && 
                            this.drawer.classList.contains('drawer-open')) {
                            this.closeDrawer();
                        }
                    });
                    this.cartDrawerObserver.observe(cartDrawer, { 
                        attributes: true, 
                        attributeFilter: ['class'] 
                    });
                }
            }
        
            removeEventListeners() {
                if (this.escapeHandler) {
                    document.removeEventListener('keydown', this.escapeHandler);
                }
            }
        }
    )
}